module.exports = __webpack_public_path__ + "static/media/iimun.39834ffd.PNG";